// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"Headline_root__6CNW7"};